import { getLocalStorageObject, setLocalStorageArray } from "./form-helpers";
/**
 * Form abandonment tracking for CF7 forms
 *
 * @example Add hidden input to the CF7 form you'd like to track abandonment on
 * `[hidden abandonment-tracking]`
 */
export class AbandonmentTracking {
  constructor($form) {
    this.$form = $form;
    this.submittedSuccessfully = false;
    this.changed = false;
    this.fieldNamesHistory = [];
    this.formEventId = this.getFormEventId();
    this.completedFields = {};
    this.abandonmentFields = {};
    this.abandonmentID = false;

    this.handleEvents();
    this.listenToBeforeUnloadEvent();
  }

  /**
   * Returns the form custom-event-id if available, or empty string otherwise.
   */
  getFormEventId() {
    return this.$form.find('[name="custom-event-id"]').attr('value') || '';
  }

  /**
   * Returns the last field name in the field name history array.
   */
  getLastEditedFieldName() {
    return this.fieldNamesHistory[this.fieldNamesHistory.length - 1];
  }

  handleEvents() {
    this.$form.on('input', (e) => {
      const fieldName = $(e.target).attr('name');

      this.changed = true;

      // Only add the field name into the history if it's not the same as the previous field name.
      if (this.getLastEditedFieldName() !== fieldName) {
        this.fieldNamesHistory.push(fieldName);
      }
    });

    this.$form.on('wpcf7submit', () => {
      this.submittedSuccessfully = true;
    });
  }

  addEvent() {
    /**
     * This push an object contains abandonment information to the GA
     *
     * @param eventAction - The name of last edited elements in the form will be passed through here.
     * @param formEventId - The custom event id of the form will be passed through here, if no exisitng one, will pass an empty string ''.
     * @param eventHistory - An array of the name of user interacted form elements will be passed through here, like ['user-first-name', 'user-last-name', 'user-first-name'].
     */
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'formAbandonment',
      eventCategory: 'Form Abandonment',
      eventAction: this.getLastEditedFieldName(),
      formEventId: this.formEventId,
      eventHistory: this.fieldNamesHistory,
    });

    document.dispatchEvent(
      new CustomEvent('GDformAbandonment', {
        detail: {
          lastField: this.getLastEditedFieldName(),
          eventHistory: this.fieldNamesHistory,
          formName: this.formEventId,
        },
      }),
    );
  }

  maybeSave() {
    this.completedFields = {};
    this.abandonmentFields = {};
    this.abandonmentID = this.$form
      .find('[data-abandonment-id]')
      .first()
      .data('abandonment-id');

    if (!this.abandonmentID || !window.location.href) {
      return;
    }

    this.$form
      .find('[data-abandonment]:not([data-abandonment-if])')
      .each((index, element) => {
        this.addToAbandonmentFields(element);
      });

    this.$form
      .find('[data-abandonment][data-abandonment-if]')
      .each((index, element) => {
        this.addToAbandonmentFields(element);
      });

    //Minimum required data so we can store it
    if (
      this.abandonmentFields['first-name'] &&
      this.abandonmentFields['email']
    ) {
      this.$form
        .find('input:not([type=hidden]), select, textarea')
        .each((index, element) => {
          if (
            $(element).attr('type') === 'checkbox' &&
            !$(element).is(':checked')
          ) {
            return;
          }

          this.addToCompletedFields(element);
        });

      const abandonmentStorage = getLocalStorageObject('gd_abandonment_f');

      abandonmentStorage[this.abandonmentID] = {
        abandonmentFields: this.abandonmentFields,
        completedFields: this.completedFields,
        url: window.location.href,
      };

      setLocalStorageArray('gd_abandonment_f', abandonmentStorage);
    }
  }

  addToAbandonmentFields(element) {
    const abandonmentData = element.querySelector('input')?.value;
    let abandonmentIf = element.dataset.abandonmentIf;
    let meetsCondition = false;

    if (abandonmentIf) {
      abandonmentIf = JSON.parse(abandonmentIf);

      Object.entries(abandonmentIf).forEach(([key, value]) => {
        if (this.$form.find('#' + key).val() === value) {
          //This only works for OR conditions
          //TODO allow AND conditions
          meetsCondition = true;
        }
      });
    } else {
      meetsCondition = true;
    }

    if (abandonmentData && meetsCondition) {
      this.abandonmentFields[element.dataset.abandonment] = abandonmentData;
    }
  }

  addToCompletedFields(element) {
    if ($(element).val()) {
      if (element.name.includes('[]')) {
        if (!this.completedFields[element.name]) {
          this.completedFields[element.name] = [];
        }

        this.completedFields[element.name].push($(element).val());
      } else {
        this.completedFields[element.name] = $(element).val();
      }
    }
  }

  listenToBeforeUnloadEvent() {
    window.addEventListener('beforeunload', () => {
      //TODO, this might not work on all browsers for ajax requests
      //Check https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon
      //

      if (this.changed === true && this.submittedSuccessfully === false) {
        this.maybeSave();
        this.addEvent();
      }
    });
  }
}
